import { differenceInCalendarDays, format } from "date-fns";
export var getRemainingDays = function (givenDate) {
    return differenceInCalendarDays(typeof givenDate === "string" ? new Date(givenDate) : givenDate, new Date());
};
export var formatDate = function (givenDate) { return format(new Date(givenDate), "MMM dd, yyyy"); };
export var formatAdminDate = function (givenDate) { return format(new Date(givenDate), "MM.dd.yyyy"); };
//# sourceMappingURL=myAccountUtils.js.map